function MoveEvaluator(evaluationThresholds) {

  // Sort the thresholds from worst to best
  const thresholds = Object.entries(evaluationThresholds)
  .sort(([, thresholdA], [, thresholdB]) => thresholdA - thresholdB); // Sort ascending

  // Return the evaluation function
  return function evaluateMove(move) {
    // Compare moveScore against the thresholds
    for (const [label, threshold] of thresholds) {
    if (move.moveDelta <= threshold) {
      return label; // Return the first matching label
      }
    }
    return 'optimal'; // Default label move is better than all thresholds
  };
}

export default MoveEvaluator;